// src/contexts/StructureContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import { getUserStructures } from '../api';

const StructureContext = createContext();

export const useStructure = () => useContext(StructureContext);

export const StructureProvider = ({ children }) => {
  const [structures, setStructures] = useState([]);
  const [currentStructure, setCurrentStructure] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStructures = async () => {
      try {
        setLoading(true);
        const response = await getUserStructures();
        setStructures(response.data);

        // Sélectionner la première structure par défaut
        if (response.data.length > 0) {
          const savedStructureId = localStorage.getItem('currentStructureId');

          if (savedStructureId) {
            const savedStructure = response.data.find(s => s.id === savedStructureId);
            if (savedStructure) {
              setCurrentStructure(savedStructure);
            } else {
              setCurrentStructure(response.data[0]);
            }
          } else {
            setCurrentStructure(response.data[0]);
          }
        } else {
          // Si l'utilisateur n'a aucune structure, on arrête le chargement proprement
          setError('Aucune structure assignée à votre compte. Contactez un administrateur.');
          setCurrentStructure(null);
        }

        if (response.data.length > 0) {
          setError(null);
        }
      } catch (err) {
        setError('Erreur lors du chargement des structures');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchStructures();
  }, []);

  const changeStructure = (structure) => {
    setCurrentStructure(structure);
    localStorage.setItem('currentStructureId', structure.id);
  };

  return (
    <StructureContext.Provider value={{ 
      structures, 
      currentStructure, 
      loading, 
      error, 
      changeStructure 
    }}>
      {children}
    </StructureContext.Provider>
  );
};